import React, { Component } from 'react'
import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { useApolloClient } from '@apollo/client'
import Cookies from 'js-cookie'
import history from '../history'

const TheHeaderDropdown = () => {

  const client = useApolloClient();
  
  const doLogout = () => {
    if (Cookies.get('token') !== undefined) {
      Cookies.remove('token');
    }
    if  (localStorage.getItem('token') !== null) {
      localStorage.removeItem('token');
    }
    if  (localStorage.getItem('username') !== null) {
      localStorage.removeItem('username');
    }    
    client.clearStore();
    history.push('/login');
  }
  
    return (
      <CDropdown
        inNav
        className="c-header-nav-items mx-2"
        direction="down"
      >
        <CDropdownToggle className="c-header-nav-link" caret={false}>
          <div className="c-avatar">
            <CImg
              src={'https://stephentaylor.ca/st.png'}
              className="c-avatar-img"
              alt="Stephen Taylor"
            />
          </div>
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownItem
            header
            tag="div"
            color="light"
            className="text-center"
          >
            <strong>Stephen Taylor</strong>
          </CDropdownItem>
          <CDropdownItem onClick={() => window.location.assign('https://www.twitter.com/stephen_taylor')}>
            <CIcon name="cib-twitter" className="mfe-2" /> 
            Twitter
          </CDropdownItem>
          <CDropdownItem onClick={() => window.location.assign('https://www.instagram.com/stephentaylor')}>
            <CIcon name="cib-instagram" className="mfe-2" /> 
            Instagram
          </CDropdownItem>
          <CDropdownItem onClick={() => window.location.assign('https://stephentaylor.substack.com')}>
            <CIcon name="cil-envelope-closed" className="mfe-2" /> 
            Newsletter
          </CDropdownItem>
          <CDropdownItem onClick={() => window.location.assign('https://stephentaylor.ca')}>
            <CIcon name="cil-comment-square" className="mfe-2" /> 
            Blog
          </CDropdownItem>
          { (localStorage.getItem('token') !== null && localStorage.getItem('username') !== null) ? <><CDropdownItem divider />
          <CDropdownItem onClick={() => doLogout()}>
            <CIcon name="cil-lock-locked" className="mfe-2" /> 
            Logout
          </CDropdownItem>
         </> : <></> } 
        </CDropdownMenu>
      </CDropdown>
    )
}

export default TheHeaderDropdown;
